/**
 * The page's own theme: the system's, or one the person picked. One cookie, `theme`, shared by
 * tellvo.app and setup.tellvo.app (Domain=.tellvo.app), so a choice on one shows on the other;
 * a technical cookie, no consent banner. Elsewhere (localhost, the dev host) it stays on this host.
 */
export type Theme = 'system' | 'light' | 'dark';
const NAME = 'theme';
const YEAR = 60 * 60 * 24 * 365;

export function loadTheme(): Theme {
  const value = readCookie(NAME);
  return value === 'light' || value === 'dark' ? value : 'system';
}

export function applyTheme(theme: Theme): void {
  if (theme === 'system') document.documentElement.removeAttribute('data-theme');
  else document.documentElement.setAttribute('data-theme', theme);
  writeCookie(NAME, theme);
}

function readCookie(name: string): string | null {
  try {
    for (const part of document.cookie.split(';')) {
      const [key, ...rest] = part.trim().split('=');
      if (key === name) return decodeURIComponent(rest.join('='));
    }
  } catch { /* cookies blocked: the system's theme */ }
  return null;
}

function writeCookie(name: string, value: string): void {
  const host = location.hostname;
  const domain = host === 'tellvo.app' || host.endsWith('.tellvo.app') ? '; Domain=.tellvo.app' : '';
  const secure = location.protocol === 'https:' ? '; Secure' : '';
  try {
    document.cookie = `${name}=${encodeURIComponent(value)}; Path=/; Max-Age=${YEAR}; SameSite=Lax${domain}${secure}`;
  } catch { /* not remembered, still applied */ }
}
